import { StepCategory } from '../../types/app_data';
import type { Step } from '../types/step';

/**
 * Ask user how often they drive
 */
export const IntroDriveCountStep: Step = {
  id: 'introDriveCount',
  pathname: '/introdrivecount',
  excludeFromProgressCalculation: true,
  canShow: (appData) => {
    // skip if isOnboardingLite is true
    if (appData.isOnboardingLite) return false;
    // skip if dwep is not selected
    if (!appData.selectedService?.dwep) {
      return false;
    }
    // skip if any other services are selected
    if (appData.selectedService?.insurance || appData.selectedService?.garage || appData.selectedService?.refi) {
      return false;
    }
    return true;
  },
  hasData: () => true,
  hasOwnData: (appData) => !!appData.introDriveCount,
  category: () => StepCategory.Intro,
};
